import React from "react";
import { Button, Modal } from "react-bootstrap";
import { LuLogOut } from "react-icons/lu";
export default function LogoutModal({ show, onHide, onLogout }) {
	return (
		<>
			<Modal centered show={show} onHide={onHide}>
				<Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
				<Modal.Body className="pt-0">
					<div className="login-box pb-0">
						<div className="login-modal-icon text-center">
							<LuLogOut size={50} />
						</div>
						<div className="section-title mb-0 mt-0">
							<h4 className="text-center">Confirm Logout</h4>
						</div>
						<p style={{ textAlign: "center", marginTop: "-10px" }}>
							Are you sure you want to logout?
						</p>

						<div className="text-center d-flex gap-2 align-items-center px-5 mt-4">
							<Button
								variant="danger"
								size="md"
								className="w-75 mb-3 "
								onClick={onLogout}>
								Yes
							</Button>
							<Button
								variant="danger"
								size="md"
								className="w-75 mb-3 "
								onClick={onHide}>
								No
							</Button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}
